package io.github.amanshuraikwar.portfolio.model

data class LinkData(
    val id: String,
    val title: String,
    val url: String
)